import loadable from '@loadable/component';

// 懒加载组件
const DeliveryBalanceQuery = loadable(() => import('./deliveryBalanceQuery/DeliveryBalanceQuery'));
const DeliveryBalanceQuery2 = loadable(() => import('./deliveryBalanceQuery2/DeliveryBalanceQuery2'));
const DeliveryBalanceWithPurchaseQuery = loadable(() => import('./deliveryBalanceWithPurchaseQuery/DeliveryBalanceWithPurchaseQuery'));
const PaymentQuery = loadable(() => import('./paymentQuery2308/PaymentQuery'));
const InvoiceInformationQuery = loadable(() => import('./invoiceInformationQuery/InvoiceInformationQuery'));
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));
const PaymentApplicationManagement = loadable(() => import('./paymentApplicationManagement/PaymentApplicationManagement'));
const PaymentApplicationInvoiceModify = loadable(() => import('./paymentApplicationManagement/paymentApplicationInvoiceModify/PaymentApplicationInvoiceModify'));

export const subRoutes = [
  {
    // M258102 【SAAS】供应商：销售结算对账单
    path: '/DeliveryBalanceQuery',
    component: DeliveryBalanceQuery
  },
  {
    // M258103 【SAAS】供应商：销售结算对账单（备货）
    path: '/DeliveryBalanceQuery2',
    component: DeliveryBalanceQuery2
  },
  {
    // M258104 【SAAS】供应商：销售结算对账单（集采标志））
    path: '/DeliveryBalanceWithPurchaseQuery',
    component: DeliveryBalanceWithPurchaseQuery
  },
  {
    // M258111 【SAAS】供应商：医院回款单查询
    path: '/PaymentQuery',
    component: PaymentQuery
  },
  {
    // M258112 【SAAS】供应商：结算发票查询
    path: '/InvoiceInformationQuery',
    component: InvoiceInformationQuery
  },
  {
    // M258101 【SAAS】供应商：销售结算确认管理
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  {
    // M258101 【SAAS】供应商：销售结算确认管理 明细编辑
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  {
    // M258110: 供应商：发票上交申请管理
    path: '/PaymentApplicationManagement',
    component: PaymentApplicationManagement
  },
  {
    // M258110: 供应商：发票上交申请管理发票编辑
    path: '/PaymentApplicationInvoiceModify',
    component: PaymentApplicationInvoiceModify
  }
];
